"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEntryUrl = exports.SET_ENTRY_URL = exports.ENTRY_URL = void 0;
exports.ENTRY_URL = '[EntryUrl]';
exports.SET_ENTRY_URL = `${exports.ENTRY_URL} SET`;
const setEntryUrl = ({ url = '' }) => ({
    type: exports.SET_ENTRY_URL,
    payload: url,
    meta: { feature: exports.ENTRY_URL },
});
exports.setEntryUrl = setEntryUrl;
//# sourceMappingURL=entryUrl.js.map